/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 07-07-2026
 *
 * Normfeedback-icoon (vraagteken) bij een node: toont per node de meldingen
 * die de normmatch-engine voor die node heeft opgeleverd. Vervangt de ng1
 * `normfeedback`-directive.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DlNodeDomBallonComponent} from '../dl-node-dom-ballon/dl-node-dom-ballon.component';
import {BaseFeedbackIconComponent} from '../base-feedback-icon.component';

@Component({
    selector: 'dl-normfeedback',
    standalone: true,
    imports: [DlNodeDomBallonComponent, TranslateModule],
    templateUrl: './dl-normfeedback.component.html',
    styleUrls: ['./dl-normfeedback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DlNormfeedbackComponent extends BaseFeedbackIconComponent {

    protected readonly iconSelector = '.normfeedback-container .normfeedback';

    //Of er een fout bij kwam staat sinds de herbouw van de "is nieuw"-bepaling in de meldingen zelf;
    //de basis leest hem daar. Dit component hoeft de NormService dus niet meer te kennen.
}
